export const LIKE = 'like';
export const DISLIKE = 'dislike';

export const QUERY_NAME = 'recs';

export const MAJOR_APPLIANCE = 'MAJOR_APPLIANCE';
export const LIKE_CLICK = 'instant-recs-like.click';
export const DISLIKE_CLICK = 'instant-recs-dislike.click';

// INSTANT RECS
export const THUMBS_UP_GRAY = 'thumbs-up-gray.svg';
export const THUMBS_UP_ORANGE = 'thumbs-up-orange.svg';
export const THUMBS_DOWN = 'thumbs-down-gray.svg';
export const HOME_DEPOT_DESIGN_CENTER = 'HDDC';

export const POD_IMAGE_SIZE = 300;

// ATC DRAWER RECOMMENDATION
export const RECOMMENDATIONS = {
  TITLE: {
    atc: 'Suggested Items',
    essential_accessories: 'Don\'t Forget This'
  },
  IMPRESSION: {
    ID: {
      atc: '00ATCDEFVALSI00',
      essential_accessories: '00ATCDEFVALEA00',
      cart_instock: '00ATCDEFVALSIMI00',
      pipcollection: '00ATCDEFVALPC00',
      brand_based_collection: '00ATCDEFVALBBR00',
      battery_collection: '00ATCDEFVALBC00'
    }
  }
};

export const TIMEOUT = 3000;